import amenities from './amenities'
import upcomingReservations from './upcomingReservations'

export default {
  amenities,
  upcomingReservations,
}
